// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2c0Hy","table":"styles_table__38gbr"};